<h2 mat-dialog-title>Add to Cart</h2>
<mat-dialog-content class="mat-typography">
  <div class="main">
    <div class="details">
      <h1>{{data.dressData.dress_name}}</h1>
      <h2>Size: {{data.dressData.size}} <span><i class="fas fa-heart"></i><i class="fas fa-heart"></i><i
            class="fas fa-heart"></i><i class="fas fa-heart"></i><i class="far fa-heart"></i></span></h2>
      <div class="dress-details">
        <p>Shoulders: {{data.dressData.shoulder}}</p>
        <p>Neck: {{data.dressData.neck}}</p>
        <p>Waist: {{data.dressData.waist}}</p>
        <p>Sleeves: {{data.dressData.sleeves}}</p>
      </div>
      <p>
        Status:
        <span *ngIf="data.dressData.status=='1'">Dress is available to rent</span>
        <span *ngIf="data.dressData.status=='2'">Dress is not currently available to rent</span>
      </p>
      <span class="days"><input min="1" type="number" name='days' [(ngModel)]="days" style="width:3em; height:2em"> No. of
        Days</span>
      <p *ngIf="warning">Must Provide Number of Days</p>
      <h3 class="rent">Rent: {{data.dressData.basic_rent}}</h3>
      <button *ngIf="data.dressData.status=='1' && authenticated==true" class="add"
        (click)="addToCart(data.dressData)">Add to Cart</button>
      <button *ngIf="data.dressData.status=='2' || authenticated==false" class="add disabled" disabled>Add to
        Cart</button>
    </div>
    <p *ngIf=" authenticated==false">
      Note:
      <span>You must log in to add dress</span>
    </p>
  </div>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>